import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

export default function SectionHeader({
  heading,
  description,
  sectionIcon,
  section,
  className,
}: {
  heading: string;
  description: string;
  sectionIcon: React.ReactNode;
  section: string;
  className?: string;
}) {
  return (
    <div
      className={cn("flex flex-col gap-6 py-4 lg:py-8", className)}
    >
      <Badge
        variant="outline"
        className="w-fit gap-1 bg-card px-3 text-sm font-normal tracking-tight shadow-sm"
      >
        {sectionIcon}
        <span>{section}</span>
      </Badge>

      <h2 className="text-3xl leading-tight tracking-tight md:text-4xl lg:text-5xl">
        {heading}
      </h2>
      <p className="max-w-[600px] tracking-[-0.32px] text-muted-foreground">
        {description}
      </p>
    </div>
  );
}
